import {
    IN_PROGRESS_ORDERS_LOADING,
    IN_PROGRESS_ORDERS_LOADING_DONE,
    IN_PROGRESS_ORDERS_INIT,
    IN_PROGRESS_ORDERS_SEARCH,
} from '../../actions';

const INITIAL_STATE = {
    loading: false,
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 0,
    number: 0,
};

const inProgressOrders = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case IN_PROGRESS_ORDERS_SEARCH:
            return {
                ...state,
                ...payload,
            };

        case IN_PROGRESS_ORDERS_INIT:
            return { ...INITIAL_STATE };

        case IN_PROGRESS_ORDERS_LOADING:
            return {
                ...state,
                loading: true,
            };

        case IN_PROGRESS_ORDERS_LOADING_DONE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};
export default inProgressOrders;
